var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yt-school-list"},[_c('GridTable',{ref:"gridTable",attrs:{"id":"SchoolList","title":_vm.title,"urlPath":"schoolsCms","columns":_vm.columns,"schema":_vm.schema,"afterSaveHook":_vm.afterSaveHook,"defaultServerParams":{
      _fields: '_id,name,domain,isActive,totalTutors,totalStudents,createdAt',
      _sort: 'createdAt',
      _order: 'desc'
    }},scopedSlots:_vm._u([{key:"customButtons",fn:function(slotProps){return [_c('router-link',{staticClass:"btn btn-success",attrs:{"to":{
          name: 'SubjectList',
          query: { schoolId: slotProps.props.row._id }
        }}},[_vm._v("Subjects")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee5ba55","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/schools/SchoolList.vue
// module id = null
// module chunks = 